<template>
	<div id="survey" class="container">
		<div class="deco-wireframe"></div>

		<div class="position-absolute top-50 start-50 translate-middle">
			<div class="row">
				<div class="mb-3 mb-sm-3 mb-md-6 m-auto col-12 text-center">
					<img
						class="img-fluid logo"
						src="./../../assets/logo.svg"
						alt=""
					/>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-sm-10 m-auto">
					<div>
						<h2 class="c-main-blue fw-bold lh-base ff-ch">
							請問有使用過以下哪些評測系統？<br
								class="d-md-none"
							/>（可複選）</h2
						>
					</div>
					<form class="mt-3">
						<div class="d-inline-block text-start ff-ch fs-0">
							<div>
								<div class="form-check mt-3 lh-base">
									<input
										type="checkbox"
										class="form-check-input mt-2"
										id="system-1"
										v-model="system[0]"
									/>
									<div class="ff-ch lh-base">
										CHOP INTEND Assessment
										表單評測系統，使用
										<input
											type="number"
											class="form-years"
											step="0.5"
											min="0.5"
											v-model="years[0]"
										/>
										年
									</div>
								</div>
							</div>
							<div>
								<div class="form-check mt-3 lh-base">
									<input
										type="checkbox"
										class="form-check-input mt-2"
										id="system-2"
										v-model="system[1]"
									/>
									<div class="ff-ch lh-base">
										HFMSE Assessment 評測系統，使用
										<input
											type="number"
											class="form-years"
											step="0.5"
											min="0.5"
											v-model="years[1]"
										/>
										年
									</div>
								</div>
							</div>
							<div>
								<div class="form-check mt-3 lh-base">
									<input
										type="checkbox"
										class="form-check-input mt-2"
										id="system-3"
										v-model="system[2]"
									/>
									<div class="ff-ch lh-base">
										RULM Assessment 評測系統，使用
										<input
											type="number"
											class="form-years"
											step="0.5"
											min="0.5"
											v-model="years[2]"
										/>
										年
									</div>
								</div>
							</div>

							<div>
								<div
									class="btn btn-primary mt-6 w-100 ff-ch fw-light fs-0"
									@click="form_submit"
								>
									<i
										data-feather="send"
										width="18"
										stroke-width="2"
									></i>
									確認 (送出後不可更改)
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
		<footer class="footer">
			<div class="row g-0 justify-content-between fs--1 mt-4 mb-3 ff-ch">
				<div class="col-12 col-sm-auto text-center">
					<p class="mb-0 text-600"
						>Thank you for joining the SMA PowerUp</p
					>
				</div>
				<div class="col-12 col-sm-auto text-center">
					<p class="mb-0 text-600 lh-base">
						2021
						<a href="">©Biogen</a> copy rights reserved
						<span class="d-none d-sm-inline">|</span
						><br class="d-sm-none" />
						Biogen-145353-TW-12/2021
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
import Api from "./../../script/api";
import { mapGetters } from "vuex";
export default {
	data() {
		return {
			system: [false, false, false],
			years: ["", "", ""],
		};
	},

	mounted() {
		feather.replace();
	},

	computed: {
		...mapGetters({ token: "getToken", userData: "getUserData" }),
	},

	methods: {
		form_submit() {
			for (let i = 0; i < 3; i++) {
				if (this.system[i] && !this.years[i]) {
					alert("請勾選使用過的評測系統，並填寫使用時間");
					return;
				} else if (!this.system[i] && this.years[i]) {
					alert("請勾選使用過的評測系統，並填寫使用時間");
					return;
				}
			}
			const formData = {
				a_years:
					this.system[0] && this.years[0] > 0 ? this.years[0] : "",
				b_years:
					this.system[1] && this.years[1] > 0 ? this.years[1] : "",
				c_years:
					this.system[2] && this.years[2] > 0 ? this.years[2] : "",
			};

			Api.post_header(
				"api/survay_do",
				{ Authorization: `Bearer ${this.token}` },
				formData,
				async (res) => {
					if (res.res && res.msg === "ok") {
						await this.$store.dispatch(
							"handleSetUserData",
							this.token
						);
						this.$router.push("/test");
					} else {
						this.system_1 = false;
						this.system_2 = false;
						this.system_3 = false;
						this.a_years = "";
						this.b_years = "";
						this.c_years = "";
						alert(res.responseJSON.msg);
					}
				}
			);
		},
	},
};
</script>

<style lang="scss" scoped>
#survey.container {
	min-height: 100vh;

	> div {
		width: 100%;
	}
}

.col-12.col-sm-10.m-auto {
	width: auto;
}

.form-years {
	// margin: 0 6px;
	width: 60px;
}

label {
	display: inline;
}

input {
	display: inline;
	white-space: nowrap;
	text-align: center;
	border: 0.5px solid #333;
}

input:focus {
	outline: none;
}

h2 {
	font-size: 20px;
}

@media screen and (max-width: 1400px) {
	#survey {
		.position-absolute {
			.row {
				.col-12.col-sm-10.m-auto {
					h2 {
						font-size: 18px;
					}
				}
			}
		}
	}
}

@media screen and (max-width: 768px) {
	#survey {
		.position-absolute {
			.row {
				.col-12.col-sm-10.m-auto {
					h2 {
						font-size: 16px;
						text-align: center;
						margin-top: 1.5rem;
					}
				}
			}
		}
	}
}

@media screen and (max-width: 576px) {
	#survey {
		.position-absolute {
			.row {
				padding: 0 1.5rem;
			}
		}
	}
}
</style>
